// redux/slices/googleAuthSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import handleAsyncThunk from '../handleAsyncThunk';
import cartApi from '../../services/cartApi';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { resetPaymentButtonIntentState } from './paymentSlice';
import { fetchUserPointsAndRewards } from './rewardSlice';
import { addTokensFromCart, removeTokenFromSelectedTokens } from './sportSlice';

export const getMyCart = createAsyncThunk('cart/getUserCartTokens', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.getUserCartTokens(data);
        if (response.status === 0) {
            // update cart
            dispatch(updateCart(response?.data?.tokens?.orderItems));

            return response?.data?.tokens; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const removeTokenFromCart = createAsyncThunk('cart/removeTokenFromCart', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.removeTokenFromCart(data);
        if (response.status === 0) {
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            // dispatch(removeFromCart(data));
            dispatch(updateCart(response?.data?.cartDetails?.orderItems));

            dispatch(removeTokenFromSelectedTokens({
                xAxis: data?.tokenData[0]?.xAxis,
                yAxis: data?.tokenData[0]?.yAxis,
            }));
            
            // dispatch(getAllPurchasedOrMyCartTokens({ seasonId: data.seasonId }));

            return response?.data; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const removecartItem = createAsyncThunk('cart/removecartItem', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.removecartItem(data);
        if (response.status === 0) {
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const clearWholeCart = createAsyncThunk('cart/clearWholeCart', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.clearWholeCart(data);
        if (response.status === 0) {
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(getMyCart({
                seasonId: data?.seasonId
            }));
            return response?.data; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const saveToCart = createAsyncThunk('cart/saveToCart', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.addToCart(data);
        if (response.status === 0) {
            // show add-to-cart toast message
            dispatch(showSuccessSnackbar({ title: 'Added to cart' }));
            
            // dispatch(getAllPurchasedOrMyCartTokens({ seasonId: data.seasonId }))
            // add cart
            dispatch(updateCart(response?.data?.orderDetails?.orderItems));
            dispatch(addTokensFromCart({
                ispurchased: false,
                purchaseType: "1",
                matchIds: [],
                isMyToken: true,
                xAxis: data?.tokenData[0]?.xAxis,
                yAxis: data?.tokenData[0]?.yAxis,
            }));
            return response?.data; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const checkoutPayment = createAsyncThunk('cart/checkoutPayment', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.checkoutPayment(data);
        if (response.status === 0) {
            if(response?.data?.status === true) {
                // Redirect to payment page
                dispatch(showSuccessSnackbar({ title: response?.data?.message }));
                dispatch(clearTokens()); // Clear tokens
                dispatch(resetPaymentButtonIntentState()); // reset payment-intent state
                return response?.data 
            }else{
                dispatch(showErrorSnackbar({ title: response?.data?.message }));             // Show Error-Snackbar/ Toast
                dispatch(setAlreadyPurchasedTokens(response?.data?.alreadyPurchasedTokens)); // Set already purchased tokens in redux store
                dispatch(setUnavailableTokens(response?.data?.unavailableTokens));          // Set unavailable tokens in redux store
            }

            return response?.data; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const updatePayment = createAsyncThunk('payment/updatePaymentStatus', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.paymentStatus(data);
        dispatch(fetchUserPointsAndRewards({ seasonId: data?.seasonId }));

        if (response.status === 0) {
            dispatch(deleteCart({ seasonId: data?.seasonId }));
            // update user-info
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data; // Return the response data on success
        } else {
            // dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const startProcessingPayment = createAsyncThunk('payment/startProcessingPayment', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.startProcessingPayment(data);
        if (response.status === 0) {
            // dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            return response?.data; // Return the response data on success
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})


// FOR DEMO
export const checkoutPaymentCoins = createAsyncThunk('cart/checkoutPaymentCoins', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await cartApi.checkoutPaymentCoins(data);
        if (response.status === 0) {
            if(response?.data?.status === true) {
                // Redirect to payment page
                dispatch(showSuccessSnackbar({ title: response?.data?.message }));
                dispatch(clearTokens()); // Clear tokens
                dispatch(resetPaymentButtonIntentState()); // reset payment-intent state
                return response?.data 
            }else{
                dispatch(showErrorSnackbar({ title: response?.data?.message }));             // Show Error-Snackbar/ Toast
                dispatch(setAlreadyPurchasedTokens(response?.data?.alreadyPurchasedTokens)); // Set already purchased tokens in redux store
                dispatch(setUnavailableTokens(response?.data?.unavailableTokens));          // Set unavailable tokens in redux store
            }

            return response?.data; // Return the response data on success
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue({
                message: response?.message,
                code: response?.code || null, // Ensure code is included
              }); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    isLoading: false,
    apiData: null,
    products: [],  // list of products in cart
    totalCount: 0, // total number of items in cart
    error: null,
    cartData: null,
    checkoutApiData: null,
    alreadyPurchasedTokens: [], // New state property
    unavailableTokens: [], // New state property
    cartFetched: false,
  },
  reducers: {
    addToCart: (state, action) => {
        if(state.products?.length === 0) {
            let arr = []
            arr.push(action.payload);
            state.products = [...arr];
            state.totalCount += arr?.length;
        }else{
            state.products?.push(action.payload);
            state.totalCount += action.payload?.length;
        }
    },
    removeFromCart: (state, action) => {
        const product = action.payload;
        state.products = state.products.filter((p) => p._id !== product._id);
        state.totalCount -= 1;
    },
    deleteCart: (state, action) => {
        if(state.cartData && state.cartData?.seasonId === action.payload?.seasonId) {
            state.products = [];
            state.totalCount = 0;
            state.cartData = null;
        }
    },
    updateCart: (state, action) => {
        state.products = action.payload || [];
        const count = action.payload?.reduce((acc, item) => acc + item?.tokenQuantity, 0);
        state.totalCount = count || 0;
        state.cartFetched = true;
    },
    setAlreadyPurchasedTokens: (state, action) => {
        state.alreadyPurchasedTokens = action.payload;
    },
    setUnavailableTokens: (state, action) => {
        state.unavailableTokens = action.payload;
    },
    clearTokens: (state) => { // Clear function to reset token states
        state.alreadyPurchasedTokens = [];
        state.unavailableTokens = [];
    },
    cancelCheckout: (state) => {
        state.checkoutApiData = null;
    }
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, getMyCart, 'cartData', 'error', 'loadingCart');
    handleAsyncThunk(builder, removecartItem, 'apiData', 'error', 'removingCartItem');
    handleAsyncThunk(builder, clearWholeCart, 'clearCart', 'error', 'clearingCart');
    handleAsyncThunk(builder, saveToCart, 'apiData', 'error', 'savingToCart');
    handleAsyncThunk(builder, removeTokenFromCart, 'apiData', 'error', 'removingTokenFromCart');
    handleAsyncThunk(builder, checkoutPayment, 'checkoutApiData', 'error', 'checkingOutPayment');
    handleAsyncThunk(builder, updatePayment, 'updatePaymentApiData', 'error', 'updatingPayment');
    handleAsyncThunk(builder, startProcessingPayment, 'apiData', 'error', 'isPaymentProcessingStarted');
    handleAsyncThunk(builder, checkoutPaymentCoins, 'checkoutCoinsApiData', 'checkoutCoinsError', 'checkingOutPaymentCoins');
  },
});

export const { addToCart, removeFromCart, deleteCart, updateCart, setAlreadyPurchasedTokens, setUnavailableTokens, clearTokens, cancelCheckout } = cartSlice.actions

export default cartSlice.reducer;
